import React, { useState, useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ButtonGroupExt from '../../../../../legacy/components/ButtonGroupExt'
import CheckboxBlock from '../../../../../legacy/components/CheckboxBlock'
import InputBlock from '../../../../../legacy/components/InputBlock'
import { debounce } from '../../../../../utils/debounce'
import validatorWrapper from '../../../../../utils/validatorWrapper'
import useStaticData from '../../../common/useStaticData'
import { dowelingCalculation } from '../../../store/calculationAction'
import { useAlertModal } from '../../../../../legacy/components/AlertModal'
import DropdownBlock from '../../../../../legacy/components/DropdownBlock'

const Doweling = () => {
  const dispatch = useDispatch()

  const calculation = useSelector((state) => state.calculation)
  const staticData = useSelector((state) => state.staticData)
  const {
    adhesiveAnchor,
    insertType,
    insertDiameter,
    drillBitDiameter,
    embedmentDepth,
    screenTube,
    numberInstallations,
    overageFactor,
    waterFilledHoles,
    validation,
  } = calculation.input
  // data
  const {
    getModels,
    getApitchOrArebar,
    getInsertDiameterOptions,
    getProductOptions,
    getDrillBitDiameterOptions,
    getScreenTubeOptions,
    showWaterFilledHolesInput,
  } = useStaticData(staticData)
  const { helpText, dowelingOptions } = staticData

  const models = useMemo(() => getModels(adhesiveAnchor), [adhesiveAnchor])
  const aPitchOrArebar = useMemo(
    () => getApitchOrArebar(insertDiameter, insertType),
    [insertDiameter, insertType],
  )
  const insertDiameterOptions = useMemo(() => getInsertDiameterOptions(insertType), [insertType])
  const adhesiveAnchorOptions = useMemo(
    () => getProductOptions(insertType, insertDiameter),
    [insertType, insertDiameter],
  )
  const drillBitDiameterOptions = useMemo(
    () => getDrillBitDiameterOptions(adhesiveAnchor, insertType, insertDiameter),
    [adhesiveAnchor, insertType, insertDiameter],
  )
  const screenTubeApplication =
    insertType === 'Plastic Screen Tube' || insertType === 'Steel Screen Tube'
  const screenTubeOptions = useMemo(
    () => getScreenTubeOptions(adhesiveAnchor, insertType, insertDiameter),
    [adhesiveAnchor, insertType, insertDiameter],
  )

  const showWaterFilledHoles = useMemo(
    () => showWaterFilledHolesInput(insertType, adhesiveAnchor),
    [insertType, adhesiveAnchor],
  )

  // for AdhesiveAnchorModal
  const [adhesiveAnchorModalProps, AdhesiveAnchorModal] = useAlertModal()
  const [newAnchorValue, setNewAnchorValue] = useState('')
  const handleButtonGroupClickForModal = (name, value) => {
    setNewAnchorValue(value)
    adhesiveAnchorModalProps.openModal()
  }
  const handleAdhesiveAnchorSubmitClick = () => {
    onChangeAdhesiveAnchor('adhesiveAnchor', newAnchorValue)
  }

  // for InsertTypeModal
  const [insertTypeModalProps, InsertTypeModal] = useAlertModal()
  const [newInsertType, setNewInsertType] = useState('')
  const handleInsertTypeButtonGroupClick = (name, value) => {
    setNewInsertType(value)
    const myInsertDiameter = getInsertDiameter(value)
    const myAdhesiveAnchor = getAdhesiveAnchor(value, myInsertDiameter)

    if (myAdhesiveAnchor !== adhesiveAnchor) {
      insertTypeModalProps.openModal()
    } else {
      onChangeInsertType('insertType', value)
    }
  }
  const handleInsertTypeSubmitClick = () => {
    onChangeInsertType('insertType', newInsertType)
  }

  // // for InsertDiameterModal
  const [insertDiameterModalProps, InsertDiameterModal] = useAlertModal()
  const [newInsertDiameter, setNewInsertDiameter] = useState('')
  const handleInsertDiameterClick = (name, value) => {
    setNewInsertDiameter(value)
    const myAdhesiveAnchor = getAdhesiveAnchor(insertType, value)

    if (myAdhesiveAnchor !== adhesiveAnchor) {
      insertDiameterModalProps.openModal()
    } else {
      onChangeInsertDiameter('insertDiameter', value)
    }
  }
  const handleInsertDiameterSubmitClick = () => {
    onChangeInsertDiameter('insertDiameter', newInsertDiameter)
  }

  const getInsertDiameter = (insertTypeValue) => {
    const opts = getInsertDiameterOptions(insertTypeValue)
    const opt = opts.length === 1 ? opts[0] : opts.find((item) => item.value === insertDiameter) // insertDiameter from state
    const myInsertDiameter = opt ? opt.value : opts.find((item) => item.default === true).value
    return myInsertDiameter
  }

  const getAdhesiveAnchor = (insertTypeValue, insertDiameterValue) => {
    const opts = getProductOptions(insertTypeValue, insertDiameterValue)
    const opt = opts.length === 1 ? opts[0] : opts.find((item) => item.value === adhesiveAnchor) // adhesiveAnchor from state
    const myAdhesiveAnchor = opt ? opt.value : opts.find((item) => item.default === true).value
    return myAdhesiveAnchor
  }

  const getDrillBitDiameter = (adhesiveAnchorValue, insertTypeValue, insertDiameterValue) => {
    const opts = getDrillBitDiameterOptions(
      adhesiveAnchorValue,
      insertTypeValue,
      insertDiameterValue,
    )
    const opt = opts.length === 1 ? opts[0] : opts.find((item) => item.value === drillBitDiameter) // drillBitDiameter from state
    const myDrillBitDiameter = opt ? opt.value : opts[0].value // The first option is the default
    return myDrillBitDiameter
  }

  const dispatchAndCalculate = (payload) => {
    dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: payload })
    const updatedInput = Object.assign({}, calculation.input, payload)
    dispatch(dowelingCalculation(updatedInput, staticData))
  }

  const onChangeAdhesiveAnchor = (name, value) => {
    dispatch({ type: 'JOB_CLEANUP' })

    const myAdhesiveAnchorModel = getModels(value).find(
      (item) => item.product === value && item.default === true,
    ).model
    const myDrillBitDiameter = getDrillBitDiameter(value, insertType, insertDiameter)
    const screenTubeOptions = screenTubeApplication
      ? getScreenTubeOptions(value, insertType, insertDiameter)
      : null
    // no need to reset embedmentDepth value whenswitching adhesive
    // const myDepth = screenTubeApplication ? {screenTube: screenTubeOptions[0].value, embedmentDepth: undefined } : { embedmentDepth: 6, screenTube: undefined }
    const showWaterFilledHoles = showWaterFilledHolesInput(insertType, value)
    const myWaterFilledHoles = showWaterFilledHoles
      ? { waterFilledHoles: false }
      : { waterFilledHoles: undefined }

    const payload = Object.assign(
      {},
      {
        [name]: value,
        adhesiveAnchorModel: myAdhesiveAnchorModel,
        drillBitDiameter: myDrillBitDiameter,
      },
      myWaterFilledHoles,
      screenTubeApplication && { screenTube: screenTubeOptions[0].value },
    )

    dispatchAndCalculate(payload)
  }

  const onChangeInsertDiameter = (name, value) => {
    const myAdhesiveAnchor = getAdhesiveAnchor(insertType, value)

    if (myAdhesiveAnchor !== adhesiveAnchor) {
      dispatch({ type: 'JOB_CLEANUP' })
    }
    const myAdhesiveAnchorModel = getModels(myAdhesiveAnchor).find(
      (item) => item.product === myAdhesiveAnchor && item.default === true,
    ).model
    const myDrillBitDiameter = getDrillBitDiameter(myAdhesiveAnchor, insertType, value)
    const screenTubeOptions = screenTubeApplication
      ? getScreenTubeOptions(myAdhesiveAnchor, insertType, value)
      : null
    const myDepth = screenTubeApplication
      ? { screenTube: screenTubeOptions[0].value, embedmentDepth: undefined }
      : { embedmentDepth: 6, screenTube: undefined }
    const showWaterFilledHoles = showWaterFilledHolesInput(insertType, myAdhesiveAnchor)
    const myWaterFilledHoles = showWaterFilledHoles
      ? { waterFilledHoles: false }
      : { waterFilledHoles: undefined }

    const payload = Object.assign(
      {},
      {
        [name]: value,
        adhesiveAnchor: myAdhesiveAnchor,
        adhesiveAnchorModel: myAdhesiveAnchorModel,
        drillBitDiameter: myDrillBitDiameter,
      },
      myDepth,
      myWaterFilledHoles,
    )

    dispatchAndCalculate(payload)
  }

  const onChangeInsertType = (name, value) => {
    const myInsertDiameter = getInsertDiameter(value)
    const myAdhesiveAnchor = getAdhesiveAnchor(value, myInsertDiameter)

    if (myAdhesiveAnchor !== adhesiveAnchor) {
      dispatch({ type: 'JOB_CLEANUP' })
    }
    const myAdhesiveAnchorModel = getModels(myAdhesiveAnchor).find(
      (item) => item.product === myAdhesiveAnchor && item.default === true,
    ).model
    const myDrillBitDiameter = getDrillBitDiameter(myAdhesiveAnchor, value, myInsertDiameter)
    const screenTubeApplication = value == 'Plastic Screen Tube' || value == 'Steel Screen Tube'
    const screenTubeOptions = screenTubeApplication
      ? getScreenTubeOptions(myAdhesiveAnchor, value, myInsertDiameter)
      : null
    const myDepth = screenTubeApplication
      ? { screenTube: screenTubeOptions[0].value, embedmentDepth: undefined }
      : { embedmentDepth: 6, screenTube: undefined }
    const showWaterFilledHoles = showWaterFilledHolesInput(value, myAdhesiveAnchor)
    const myWaterFilledHoles = showWaterFilledHoles
      ? { waterFilledHoles: false }
      : { waterFilledHoles: undefined }

    const payload = Object.assign(
      {},
      {
        [name]: value,
        insertDiameter: myInsertDiameter,
        adhesiveAnchor: myAdhesiveAnchor,
        adhesiveAnchorModel: myAdhesiveAnchorModel,
        drillBitDiameter: myDrillBitDiameter,
        validation: {
          ...calculation.input.validation,
          embedmentDepth: '',
        },
      },
      myDepth,
      myWaterFilledHoles,
    )

    dispatchAndCalculate(payload)
  }

  const handleInputChange = (name, myValue, status, validationMethods) => {
    const value = myValue.replace(/,/g, '')
    const errors = validatorWrapper.validate(validationMethods, value)
    const msg = !errors || errors.length === 0 ? '' : errors[0]
    const payload = [].concat({ [name]: value }).concat({ [name]: msg }) // payload[0] for input, payload[1] for validation

    dispatch({ type: 'FIELD_INPUT_CALCULATION', payload: payload })

    let updatedInput = Object.assign({}, calculation.input, payload[0]) // payload[0] for state.input
    updatedInput.validation = Object.assign({}, updatedInput.validation, payload[1])

    delayedCalculation(updatedInput, staticData /*, models, aPitchOrArebar, showWaterFilledHoles */)
  }

  const delayedCalculation = useCallback(
    debounce((updatedInput, staticData) => {
      dispatch(dowelingCalculation(updatedInput, staticData))
    }, 500),
    [],
  )

  const onChangeExt = (name, value) => {
    const payload = { [name]: value }

    dispatch({ type: 'FIELD_UPDATE_CALCULATION', payload: payload })
    const updatedInput = Object.assign({}, calculation.input, payload)
    dispatch(dowelingCalculation(updatedInput, staticData))
  }

  const insertDiameterProps = {
    dropdownProps: {
      selection: true,
      'data-testid': 'insertDiameter'
    },
    name: 'insertDiameter',
    value: insertDiameter,
    options: insertDiameterOptions,
    label: `Insert Diameter (${insertType})`,
    popoverText: '',
    onChange: handleInsertDiameterClick,
  }

  const drillBitDiameterProps = {
    dropdownProps: {
      selection: true,
      'data-testid': 'drillBitDiameter'
    },
    name: 'drillBitDiameter',
    value: drillBitDiameter,
    options: drillBitDiameterOptions,
    label: 'Drill Bit Diameter',
    popoverText: '',
    onChange: onChangeExt,
  }

  const screenTubeProps = {
    dropdownProps: {
      selection: true,
      'data-testid': 'screenTube'
    },
    name: 'screenTube',
    value: screenTube,
    options: screenTubeOptions,
    label: 'Screen Tube',
    popoverText: helpText['screenTube'],
    onChange: onChangeExt,
  }

  const overageFactorProps = {
    dropdownProps: {
      selection: true,
      'data-testid': 'overageFactor'
    },
    name: 'overageFactor',
    value: overageFactor,
    options: dowelingOptions['overageFactor'],
    label: 'Overage Factor',
    popoverText: helpText['overageFactor'],
    onChange: onChangeExt,
  }

  const waterFilledHolesProps = {
    name: 'waterFilledHoles',
    value: waterFilledHoles,
    inputLabel: 'Install anchors in water filled holes',
    label: 'Water Filled Holes',
    popoverText: helpText['waterFilledHoles'],
    onChange: onChangeExt,
    containerProps: {'data-testid': 'waterFilledHoles'}
  }

  return (
    <>
      <section className="dowelingInputs" id="aceDowelingInputWarningModals">
        <AdhesiveAnchorModal
          headerText={'Change Adhesive Anchor?'}
          bodyText={
            'Changing the Adhesive Anchor will clear all the current jobs from the job tally. This action cannot be undone.'
          }
          cancelButtonText={'Cancel'}
          submitButtonText={'Change Adhesive Anchor'}
          handleSubmitClick={handleAdhesiveAnchorSubmitClick}
        />

        <InsertTypeModal
          headerText={'Change Insert Type?'}
          bodyText={
            'The Insert Type that you have selected is not available for the Adhesive Anchor selected. If you proceed, this will clear all current jobs from the the job tally. This action cannot be undone.'
          }
          cancelButtonText={'Cancel'}
          submitButtonText={'Change Insert Type'}
          handleSubmitClick={handleInsertTypeSubmitClick}
        />

        <InsertDiameterModal
          headerText={'Change Insert Diameter?'}
          bodyText={
            'The Insert Diameter that you have selected is not available for the Adhesive Anchor selected. If you proceed, this will clear all current jobs from the the job tally. This action cannot be undone.'
          }
          cancelButtonText={'Cancel'}
          submitButtonText={'Change Insert Diameter'}
          handleSubmitClick={handleInsertDiameterSubmitClick}
        />
      </section>

      <section className="dowelingInputs" id="aceDowelingInputInsert">
        <h3>Insert</h3>

        <ButtonGroupExt
          name={'insertType'}
          value={insertType}
          options={dowelingOptions['insertType']}
          handleButtonClick={handleInsertTypeButtonGroupClick}
          colClass={'col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3 -skinny'}
          containerProps={{ 'data-testid': 'insertType' }}
        />
        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
            <DropdownBlock {...insertDiameterProps} />
          </div>
        </div>
      </section>

      <section id="aceDowelingInputAdhesiveAnchor">
        <h3>Adhesive Anchor</h3>

        <ButtonGroupExt
          name={'adhesiveAnchor'}
          value={adhesiveAnchor}
          options={adhesiveAnchorOptions}
          handleButtonClick={handleButtonGroupClickForModal}
          colClass={'col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3 -skinny'}
          containerProps={{ 'data-testid': 'adhesiveAnchor' }}
        />
      </section>

      <section className="dowelingInputs" id="aceDowelingInputInstallation">
        <h3>Installation</h3>

        <div className="row">
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
            <DropdownBlock {...drillBitDiameterProps} />
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
            {screenTubeApplication ? (
              <DropdownBlock {...screenTubeProps} />
            ) : (
              <InputBlock
                name={'embedmentDepth'}
                value={embedmentDepth}
                onChange={handleInputChange}
                status={validation.embedmentDepth}
                unit={'in'}
                validationMethods={['isNotEmpty', 'isDecimal', 'validEmbedmentDepth']} // , 'validEmbedmentDepth'
                label={'Embedment Depth'}
                containerProps={{ 'data-testid': 'embedmentDepth' }}
              />
            )}
          </div>

          <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
            <InputBlock
              name={'numberInstallations'}
              value={numberInstallations}
              onChange={handleInputChange}
              status={validation.numberInstallations}
              unit={''}
              validationMethods={['isNotEmpty', 'isInt', 'validNumberInstallations']}
              label={'Number Of Installations'}
              containerProps={{ 'data-testid': 'numberInstallations' }}
            />
          </div>

          <div
            className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3"
            id="aceDowelingInputOverage"
          >
            <DropdownBlock {...overageFactorProps} />
          </div>

          {showWaterFilledHoles ? (
            <div
              className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3"
              id="aceDowelingInputWaterFilled"
            >
              <CheckboxBlock {...waterFilledHolesProps} />
            </div>
          ) : null}
        </div>
      </section>
    </>
  )
}

export default Doweling
